"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPOEmailTemplate = exports.buildPOTable = void 0;
// console.log("config is", config);
exports.buildPOTable = (purchaseOrder, emailToken) => {
    const { orderName, orderDescription, transactionPONumber, customerPONumber, orderInventories, orderTotalCost, pharmacyName, note, site, id: transactionId, user, shippingMethods } = purchaseOrder;
    const { firstName, lastName, email } = user;
    const table = document.createElement("TABLE");
    table.setAttribute("class", "po-table");
    // create table head
    const tableRowHead = document.createElement("TR");
    const tableHeadNdcPkg = document.createElement("TH");
    const tableHeadName = document.createElement("TH");
    const tableHeadQuantityOnHand = document.createElement("TH");
    const tableHeadMin = document.createElement("TH");
    const tableHeadMax = document.createElement("TH");
    const tableHeadDistributor = document.createElement("TH");
    const tableHeadPrice = document.createElement("TH");
    const tableHeadOrderQuantity = document.createElement("TH");
    const tableHeadTotalCost = document.createElement("TH");
    tableHeadNdcPkg.appendChild(document.createTextNode("NDC")); //C-036
    tableHeadName.appendChild(document.createTextNode("Name")); //C-036
    tableHeadQuantityOnHand.appendChild(document.createTextNode("Qty on Hand")); //C-036
    tableHeadMin.appendChild(document.createTextNode("Min")); //C-036
    tableHeadMax.appendChild(document.createTextNode("Max")); //C-036
    tableHeadDistributor.appendChild(document.createTextNode("Distributor")); //C-036
    tableHeadPrice.appendChild(document.createTextNode("Price")); //C-036
    tableHeadOrderQuantity.appendChild(document.createTextNode("Qty")); //C-036
    tableHeadTotalCost.appendChild(document.createTextNode("Total Cost")); //C-036
    tableRowHead.appendChild(tableHeadNdcPkg);
    tableRowHead.appendChild(tableHeadName);
    tableRowHead.appendChild(tableHeadQuantityOnHand);
    tableRowHead.appendChild(tableHeadMin);
    tableRowHead.appendChild(tableHeadMax);
    tableRowHead.appendChild(tableHeadDistributor);
    tableRowHead.appendChild(tableHeadPrice);
    tableRowHead.appendChild(tableHeadOrderQuantity);
    tableRowHead.appendChild(tableHeadTotalCost);
    // Append table head to table element
    table.appendChild(tableRowHead);
    for (const inventory of orderInventories) {
        const { pkgCode, name, quantityOnHand, min, max, distributor, price, inventoryOrderQuantity, inventoryTotalCost } = inventory;
        // Create table row and append table data
        const tableRow = document.createElement("TR");
        const tableDataPkgCode = document.createElement("TD");
        const tableDataName = document.createElement("TD");
        const tableDataQuantityOnHand = document.createElement("TD");
        const tableDataMin = document.createElement("TD");
        const tableDataMax = document.createElement("TD");
        const tableDataPrice = document.createElement("TD");
        const tableDataDistributor = document.createElement("TD");
        const tableDataInventoryOrderQuantity = document.createElement("TD");
        const tableDataInventoryTotalCost = document.createElement("TD");
        tableDataPkgCode.appendChild(document.createTextNode(pkgCode));
        tableDataName.appendChild(document.createTextNode(name));
        tableDataQuantityOnHand.appendChild(document.createTextNode(String(quantityOnHand)));
        tableDataQuantityOnHand.setAttribute("class", "align-right");
        tableDataMin.appendChild(document.createTextNode(String(min)));
        tableDataMin.setAttribute("class", "align-right");
        tableDataMax.appendChild(document.createTextNode(String(max)));
        tableDataMax.setAttribute("class", "align-right");
        tableDataPrice.appendChild(document.createTextNode(String(`$${price.toFixed(2)}`)));
        tableDataPrice.setAttribute("class", "align-right");
        tableDataDistributor.appendChild(document.createTextNode(distributor ? distributor : "N/A"));
        if (!distributor) {
            tableRow.style.backgroundColor = "#ffe9e9";
        }
        tableDataInventoryOrderQuantity.appendChild(document.createTextNode(String(inventoryOrderQuantity)));
        tableDataInventoryOrderQuantity.setAttribute("class", "align-right");
        tableDataInventoryTotalCost.appendChild(document.createTextNode(`$${inventoryTotalCost.toFixed(2)}`));
        tableDataInventoryTotalCost.setAttribute("class", "align-right");
        tableRow.appendChild(tableDataPkgCode);
        tableRow.appendChild(tableDataName);
        tableRow.appendChild(tableDataQuantityOnHand);
        tableRow.appendChild(tableDataMin);
        tableRow.appendChild(tableDataMax);
        tableRow.appendChild(tableDataDistributor);
        tableRow.appendChild(tableDataPrice);
        tableRow.appendChild(tableDataInventoryOrderQuantity);
        tableRow.appendChild(tableDataInventoryTotalCost);
        table.appendChild(tableRow);
    }
    // C-022.12
    let totalInventoriesCount = 0;
    orderInventories.forEach(inventory => (totalInventoriesCount += inventory.inventoryOrderQuantity)); // C-022.12
    const tableRow = document.createElement("TR");
    const tableDataPkgCode = document.createElement("TD");
    const tableDataName = document.createElement("TD");
    const tableDataQuantityOnHand = document.createElement("TD");
    const tableDataMin = document.createElement("TD");
    const tableDataMax = document.createElement("TD");
    const tableDataPrice = document.createElement("TD");
    const tableDataDistributor = document.createElement("TD");
    const tableDataInventoryOrderQuantity = document.createElement("TD");
    const tableDataInventoryTotalCost = document.createElement("TD");
    tableDataPkgCode.appendChild(document.createTextNode("Total"));
    tableDataPkgCode.setAttribute("class", "total-ndc");
    tableDataName.appendChild(document.createTextNode(""));
    tableDataQuantityOnHand.appendChild(document.createTextNode(""));
    tableDataQuantityOnHand.setAttribute("class", "align-right");
    tableDataMin.appendChild(document.createTextNode(""));
    tableDataMin.setAttribute("class", "align-right");
    tableDataMax.appendChild(document.createTextNode(""));
    tableDataMax.setAttribute("class", "align-right");
    tableDataPrice.appendChild(document.createTextNode(""));
    tableDataPrice.setAttribute("class", "align-right");
    tableDataDistributor.appendChild(document.createTextNode(""));
    tableDataInventoryOrderQuantity.appendChild(document.createTextNode(String(totalInventoriesCount))); // C-022.12
    tableDataInventoryOrderQuantity.setAttribute("class", "total-ndc");
    tableDataInventoryTotalCost.appendChild(document.createTextNode(`$${orderTotalCost.toFixed(2)}`));
    tableDataInventoryTotalCost.setAttribute("class", "total-ndc");
    tableRow.appendChild(tableDataPkgCode);
    tableRow.appendChild(tableDataName);
    tableRow.appendChild(tableDataQuantityOnHand);
    tableRow.appendChild(tableDataMin);
    tableRow.appendChild(tableDataMax);
    tableRow.appendChild(tableDataDistributor);
    tableRow.appendChild(tableDataPrice);
    tableRow.appendChild(tableDataInventoryOrderQuantity);
    tableRow.appendChild(tableDataInventoryTotalCost);
    table.appendChild(tableRow);
    const baseUrl = "__BASE_URL_PLACEHOLDER__";
    const path = `/order/review/${transactionId}`;
    const urlToPO = `${baseUrl}${path}#po_token=${emailToken}`;
    // C-022.13 Transaction ID
    return `
    <div class="tldr">
      <div class="summary">
        <h3 class="tldr-title">Summary</h3>
        <div class="tldr-content">
            <p>Transaction ID: ${transactionId}</p>
            <p>Pharmacy name: ${pharmacyName}</p>
            <p>Order made by: ${firstName} ${lastName} (${email})</p>
            <p>Order count: ${orderInventories.length}</p>
            <p>Total order cost: $${orderTotalCost.toFixed(2)}</p>
            <p>Order note: ${note}</p>
        </div>
      </div>
      <div class="summary">
        <h3 class="tldr-title">Shipping Request</h3>
        <div class="tldr-content">
          ${shippingMethods && shippingMethods.length
        ? shippingMethods
            .map(shipping => `<p>${shipping.distributor}: ${shipping.method}</p>`)
            .join(" ")
        : ""}
        </div>
        <br/>
        <div class="">
          <h4 class="tldr-title">Payment Method: </h4>
          <h4 class="tldr-title">Distributor Rep: </h4>
        </div>
      </div>
    </div>
    <table style="border-collapse: collapse;mso-table-lspace: 0pt;mso-table-rspace: 0pt;-ms-text-size-adjust: 100%;-webkit-text-size-adjust:100%;border-spacing: 0;width: 100%;">
      <tr>
        <td style="text-align: right"><a href="${urlToPO}" target="_blank"><button class="review-button">Review in App</button></a></td>
      </tr>
     </table>
    <br />
    ${table.outerHTML}
  `;
};
// C-036 - Review in App
// C-036 - Payment Method Distributor Rep:
exports.getPOEmailTemplate = (subject, title, body) => `<!doctype html>
<html>
    <head>
      <!-- NAME: HERO CARD -->
        <!--[if gte mso 15]>
    <xml>
      <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
    </xml>
    <![endif]-->
    <meta charset="UTF-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>${subject}</title>

    <style type="text/css">
    p{
      margin:10px 0;
      padding:0;
    }
    table{
      border-collapse:collapse;
    }
    h1,h2,h3,h4,h5,h6{
      display:block;
      margin:0;
      padding:0;
    }
    img,a img{
      border:0;
      height:auto;
      outline:none;
      text-decoration:none;
    }
    body,#bodyTable,#bodyCell{
      height:100%;
      margin:0;
      padding:0;
      width:100%;
    }
    .mcnPreviewText{
      display:none !important;
    }
    #outlook a{
      padding:0;
    }
    img{
      -ms-interpolation-mode:bicubic;
    }
    table{
      mso-table-lspace:0pt;
      mso-table-rspace:0pt;
    }
    .ReadMsgBody{
      width:100%;
    }
    .ExternalClass{
      width:100%;
    }
    p,a,li,td,blockquote{
      mso-line-height-rule:exactly;
    }
    a[href^=tel],a[href^=sms]{
      color:inherit;
      cursor:default;
      text-decoration:none;
    }
    p,a,li,td,body,table,blockquote{
      -ms-text-size-adjust:100%;
      -webkit-text-size-adjust:100%;
    }
    .ExternalClass,.ExternalClass p,.ExternalClass td,.ExternalClass div,.ExternalClass span,.ExternalClass font{
      line-height:100%;
    }
    a[x-apple-data-detectors]{
      color:inherit !important;
      text-decoration:none !important;
      font-size:inherit !important;
      font-family:inherit !important;
      font-weight:inherit !important;
      line-height:inherit !important;
    }
    a.mcnButton{
      display:block;
    }
    .mcnImage,.mcnRetinaImage{
      vertical-align:bottom;
    }
    .mcnTextContent{
      word-break:break-word;
    }
    .mcnTextContent img{
      height:auto !important;
    }
    .mcnDividerBlock{
      table-layout:fixed !important;
    }
    /*
    @tab Page
    @section background style
    @tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.
    */
      body,#bodyTable,#templateFooter{
        /*@editable*/background-color:#002140;
      }
    /*
    @tab Page
    @section background style
    @tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.
    */
      #bodyCell{
        /*@editable*/border-top:0;
      }
    /*
    @tab Page
    @section heading 1
    @tip Set the styling for all first-level headings in your emails. These should be the largest of your headings.
    @style heading 1
    */
      h1{
        /*@editable*/color:#FFFFFF !important;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:26px;
        /*@editable*/font-style:normal;
        /*@editable*/font-weight:bold;
        /*@editable*/line-height:125%;
        /*@editable*/letter-spacing:normal;
        /*@editable*/text-align:center;
      }
    /*
    @tab Page
    @section heading 2
    @tip Set the styling for all second-level headings in your emails.
    @style heading 2
    */
      h2{
        /*@editable*/color:#2D9CE8 !important;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:20px;
        /*@editable*/font-style:normal;
        /*@editable*/font-weight:bold;
        /*@editable*/line-height:125%;
        /*@editable*/letter-spacing:normal;
        /*@editable*/text-align:center;
      }
    /*
    @tab Page
    @section heading 3
    @tip Set the styling for all third-level headings in your emails.
    @style heading 3
    */
      h3{
        /*@editable*/color:#505050 !important;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:18px;
        /*@editable*/font-style:normal;
        /*@editable*/font-weight:bold;
        /*@editable*/line-height:125%;
        /*@editable*/letter-spacing:normal;
        /*@editable*/text-align:left;
      }
    /*
    @tab Page
    @section heading 4
    @tip Set the styling for all fourth-level headings in your emails. These should be the smallest of your headings.
    @style heading 4
    */
      h4{
        /*@editable*/color:#2D9CE8 !important;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:16px;
        /*@editable*/font-style:normal;
        /*@editable*/font-weight:bold;
        /*@editable*/line-height:125%;
        /*@editable*/letter-spacing:normal;
        /*@editable*/text-align:center;
      }
    /*
    @tab Page
    @section image card
    @tip Set the border radius of your email's image card blocks.
    */
      .mcnImageCardTopContent,.mcnImageCardRightContent,.mcnImageCardBottomContent,.mcnImageCardLeftContent{
        /*@editable*/border-radius:6px;
      }
    /*
    @tab Preheader
    @section preheader style
    @tip Set the background color and borders for your email's preheader area.
    */
      #templatePreheader{
        /*@editable*/background-color:#002D54;
        /*@editable*/border-top:0;
        /*@editable*/border-bottom:0;
      }
    /*
    @tab Preheader
    @section preheader text
    @tip Set the styling for your email's preheader text. Choose a size and color that is easy to read.
    */
      .preheaderContainer .mcnTextContent,.preheaderContainer .mcnTextContent p{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:11px;
        /*@editable*/line-height:125%;
        /*@editable*/text-align:left;
      }
    /*
    @tab Preheader
    @section preheader link
    @tip Set the styling for your email's header links. Choose a color that helps them stand out from your text.
    */
      .preheaderContainer .mcnTextContent a{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-weight:normal;
        /*@editable*/text-decoration:underline;
      }
    /*
    @tab Header
    @section header style
    @tip Set the background color and borders for your email's header area.
    */
      #templateHeader{
        /*@editable*/background-color:#002140;
        /*@editable*/border-top:0;
        /*@editable*/border-bottom:0;
      }
    /*
    @tab Header
    @section header text
    @tip Set the styling for your email's header text. Choose a size and color that is easy to read.
    */
      .headerContainer .mcnTextContent,.headerContainer .mcnTextContent p{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:18px;
        /*@editable*/line-height:150%;
        /*@editable*/text-align:center;
      }
    /*
    @tab Header
    @section header link
    @tip Set the styling for your email's header links. Choose a color that helps them stand out from your text.
    */
      .headerContainer .mcnTextContent a{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-weight:normal;
        /*@editable*/text-decoration:underline;
      }
    /*
    @tab Body
    @section body style
    @tip Set the background color and borders for your email's body area.
    */
      #templateBody{
        /*@editable*/background-color:#002140;
        /*@editable*/border-top:0;
        /*@editable*/border-bottom:0;
      }
    /*
    @tab Body
    @section body container
    @tip Set the background color and border radius for your email's body container. [Note: Border radius is not supported in all email clients.]
    */
      #bodyBackground{
        /*@editable*/background-color:#FFFFFF;
        /*@editable*/border-radius:5px;
      }
    /*
    @tab Body
    @section body text
    @tip Set the styling for your email's body text. Choose a size and color that is easy to read.
    */
      .bodyContainer .mcnTextContent,.bodyContainer .mcnTextContent p{
        /*@editable*/color:#303030;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:16px;
        /*@editable*/line-height:150%;
        /*@editable*/text-align:left;
      }
    /*
    @tab Body
    @section body link
    @tip Set the styling for your email's body links. Choose a color that helps them stand out from your text.
    */
      .bodyContainer .mcnTextContent a{
        /*@editable*/color:#2A9AE7;
        /*@editable*/font-weight:bold;
        /*@editable*/text-decoration:none;
      }
    /*
    @tab Footer
    @section footer text
    @tip Set the styling for your email's footer text. Choose a size and color that is easy to read.
    */
      .footerContainer .mcnTextContent,.footerContainer .mcnTextContent p{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-family:Helvetica;
        /*@editable*/font-size:11px;
        /*@editable*/line-height:125%;
        /*@editable*/text-align:left;
      }
    /*
    @tab Footer
    @section footer link
    @tip Set the styling for your email's footer links. Choose a color that helps them stand out from your text.
    */
      .footerContainer .mcnTextContent a{
        /*@editable*/color:#FFFFFF;
        /*@editable*/font-weight:normal;
        /*@editable*/text-decoration:underline;
      }
    @media only screen and (max-width: 480px){
      body,table,td,p,a,li,blockquote{
        -webkit-text-size-adjust:none !important;
      }
  
  }	@media only screen and (max-width: 480px){
      body{
        width:100% !important;
        min-width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .templateContainer{
        // max-width:600px !important;
        // width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnRetinaImage{
        max-width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImage{
        height:auto !important;
        width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnCartContainer,.mcnCaptionTopContent,.mcnRecContentContainer,.mcnCaptionBottomContent,.mcnTextContentContainer,.mcnBoxedTextContentContainer,.mcnImageGroupContentContainer,.mcnCaptionLeftTextContentContainer,.mcnCaptionRightTextContentContainer,.mcnCaptionLeftImageContentContainer,.mcnCaptionRightImageContentContainer,.mcnImageCardLeftTextContentContainer,.mcnImageCardRightTextContentContainer,.mcnImageCardLeftImageContentContainer,.mcnImageCardRightImageContentContainer{
        max-width:100% !important;
        width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnBoxedTextContentContainer{
        min-width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageGroupContent{
        padding:9px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnCaptionLeftContentOuter .mcnTextContent,.mcnCaptionRightContentOuter .mcnTextContent{
        padding-top:9px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageCardTopImageContent,.mcnCaptionBottomContent:last-child .mcnCaptionBottomImageContent,.mcnCaptionBlockInner .mcnCaptionTopContent:last-child .mcnTextContent{
        padding-top:18px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageCardBottomImageContent{
        padding-bottom:9px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageGroupBlockInner{
        padding-top:0 !important;
        padding-bottom:0 !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageGroupBlockOuter{
        padding-top:9px !important;
        padding-bottom:9px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnTextContent,.mcnBoxedTextContentColumn{
        padding-right:18px !important;
        padding-left:18px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcnImageCardLeftImageContent,.mcnImageCardRightImageContent{
        padding-right:18px !important;
        padding-bottom:0 !important;
        padding-left:18px !important;
      }
  
  }	@media only screen and (max-width: 480px){
      .mcpreview-image-uploader{
        display:none !important;
        width:100% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section heading 1
    @tip Make the first-level headings larger in size for better readability on small screens.
    */
      h1{
        /*@editable*/font-size:24px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section heading 2
    @tip Make the second-level headings larger in size for better readability on small screens.
    */
      h2{
        /*@editable*/font-size:20px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section heading 3
    @tip Make the third-level headings larger in size for better readability on small screens.
    */
      h3{
        /*@editable*/font-size:18px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section heading 4
    @tip Make the fourth-level headings larger in size for better readability on small screens.
    */
      h4{
        /*@editable*/font-size:16px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Boxed Text
    @tip Make the boxed text larger in size for better readability on small screens. We recommend a font size of at least 16px.
    */
      .mcnBoxedTextContentContainer .mcnTextContent,.mcnBoxedTextContentContainer .mcnTextContent p{
        /*@editable*/font-size:18px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Preheader Visibility
    @tip Set the visibility of the email's preheader on small screens. You can hide it to save space.
    */
      #templatePreheader{
        /*@editable*/display:block !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Preheader Text
    @tip Make the preheader text larger in size for better readability on small screens.
    */
      .preheaderContainer .mcnTextContent,.preheaderContainer .mcnTextContent p{
        /*@editable*/font-size:14px !important;
        /*@editable*/line-height:115% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Header Text
    @tip Make the header text larger in size for better readability on small screens.
    */
      .headerContainer .mcnTextContent,.headerContainer .mcnTextContent p{
        /*@editable*/font-size:18px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section Body Text
    @tip Make the body text larger in size for better readability on small screens. We recommend a font size of at least 16px.
    */
      .bodyContainer .mcnTextContent,.bodyContainer .mcnTextContent p{
        /*@editable*/font-size:18px !important;
        /*@editable*/line-height:125% !important;
      }
  
  }	@media only screen and (max-width: 480px){
    /*
    @tab Mobile Styles
    @section footer text
    @tip Make the body content text larger in size for better readability on small screens.
    */
      .footerContainer .mcnTextContent,.footerContainer .mcnTextContent p{
        /*@editable*/font-size:14px !important;
        /*@editable*/line-height:115% !important;
      }
  
  }
    html {
			line-height: 1.15;
			-webkit-text-size-adjust: 100%;
			}
		body {
			margin: 0;
		}
		main {
			display: block;
		}
		h1 {
			font-size: 2em;
			margin: 0.67em 0;
		}
		hr {
			box-sizing: content-box;
				height: 0;
				overflow: visible;
		}

		pre {
			font-family: monospace, monospace;
			font-size: 1em;
		}

		a {
			background-color: transparent;
		}

		abbr[title] {
			border-bottom: none;
			text-decoration: underline;
			text-decoration: underline dotted;
		}
		b,
		strong {
			font-weight: bolder;
		}
		code,
		kbd,
		samp {
			font-family: monospace,
			monospace;
			font-size: 1em;
		}
		small {
			font-size: 80%;
		}
		sub,
		sup {
			font-size: 75%;
			line-height: 0;
			position: relative;
			vertical-align: baseline;
		}
		sub {
			bottom: -0.25em;
		}
		sup {
			top: -0.5em;
		}
		img {
			border-style: none;
		}
		button,
		input,
		optgroup,
		select,
		textarea {
			font-family: inherit;
			font-size: 100%;
			line-height: 1.15;
			margin: 0;
		}

		button,
		input {
				overflow: visible;
		}
		button,
		select {
			text-transform: none;
		}
		button,
		[type="button"],
		[type="reset"],
		[type="submit"] {
			-webkit-appearance: button;
		}
		button::-moz-focus-inner,
		[type="button"]::-moz-focus-inner,
		[type="reset"]::-moz-focus-inner,
		[type="submit"]::-moz-focus-inner {
			border-style: none;
			padding: 0;
		}
		button:-moz-focusring,
		[type="button"]:-moz-focusring,
		[type="reset"]:-moz-focusring,
		[type="submit"]:-moz-focusring {
			outline: 1px dotted ButtonText;
		}
		fieldset {
			padding: 0.35em 0.75em 0.625em;
		}
		legend {
			box-sizing: border-box;
			color: inherit;
			display: table;
			max-width: 100%;
			padding: 0;
			white-space: normal;
		}
		progress {
			vertical-align: baseline;
		}
		textarea {
			overflow: auto;
		}
		[type="checkbox"],
		[type="radio"] {
			box-sizing: border-box;
			padding: 0;
		}
		[type="number"]::-webkit-inner-spin-button,
		[type="number"]::-webkit-outer-spin-button {
			height: auto;
		}
		[type="search"] {
			-webkit-appearance: textfield;
			outline-offset: -2px;
		}
		[type="search"]::-webkit-search-decoration {
			-webkit-appearance: none;
		}
		::-webkit-file-upload-button {
			-webkit-appearance: button;
			font: inherit;
		}
		details {
			display: block;
		}
		summary {
			display: list-item;
		}
		template {
			display: none;
		}
		[hidden] {
			display: none;
		}
		.po-table {
			border-collapse: collapse;
			border-spacing: 0;
			width: 100%;
			border: 1px solid #ddd;
		}
		.po-table tr:nth-child(odd) {
			padding: 10px;
			background-color: #f9f9f9;
		}
		.po-table th {
			background-color: #e9ebf1;
			padding: 10px;

		}
		.po-table td {
			padding: 5px 5px;
		}
		.container {
      width: 85%;
      max-width: 960px;
			overflow: auto;
      padding: 25px;
      margin: 0 auto;
      box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);
		}
		.align-right {
			text-align: right;
    }
    .total-ndc {
      font-weight: bold;
      text-align: right;
    }
    .tldr {
      display: flex;
      justify-content: space-between;
    }
  	.tldr-title {

    }
   	.tldr-content {
    	margin: 0 25px;
     }
    .review-button {
      height: 50px;
      border: 1px solid white;
      border-radius: .2rem;
      background-color: #192e5b;
      color: white;
      border: 0 solid black;
      padding: .5rem;
      box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);
      cursor: pointer;
    }

    .review-button:hover {
      box-shadow:  0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px -1px rgba(0, 0, 0, .2);
    }

    .review-button:active {
        transform: scaleY(.999);
    }
    .email-title {
      color: #505050 !important;
      text-align: left;
    }

</style></head>
    <body leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">
    <center>
    <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable">
        <tr>
            <td align="center" valign="top" id="bodyCell">
                <!-- BEGIN TEMPLATE // -->
                <table border="0" cellpadding="0" cellspacing="0" width="100%">
                    <tr>
                        <td align="center" valign="top">
                        </td>
                    </tr>
                    <tr>
                        <td align="center" valign="top">
                            <!-- BEGIN HEADER // -->
                            <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templateHeader">
                                <tr>
                                    <td align="center" valign="top">
                                        <table border="0" cellpadding="0" cellspacing="0" width="1000" class="templateContainer">
                                            <tr>
                                                <td valign="top" class="headerContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 9px 18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageBlock" style="min-width:100%;">
<tbody class="mcnImageBlockOuter">
    <tr>
        <td valign="top" style="padding:9px" class="mcnImageBlockInner">
            <table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" class="mcnImageContentContainer" style="min-width:100%;">
                <tbody><tr>
                    <td class="mcnImageContent" valign="top" style="padding-right: 9px; padding-left: 9px; padding-top: 0; padding-bottom: 0;">




                    </td>
                </tr>
            </tbody></table>
        </td>
    </tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 9px 18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table></td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <!-- // END HEADER -->
                        </td>
                    </tr>
                    <tr>
                        <td align="center" valign="top">
                            <!-- BEGIN BODY // -->
                            <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templateBody">
                                <tr>
                                    <td align="center" valign="top" class="mobilePaddingRL5">
                                        <table border="0" cellpadding="0" cellspacing="0" width="1000" id="bodyBackground" class="templateContainer">
                                            <tr>
                                                <td align="center" valign="top">
                                                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                                        <tr>
                                                            <td valign="top" class="bodyContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageCardBlock">
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 9px 18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
<tbody class="mcnTextBlockOuter">
<tr>
    <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
        <!--[if mso]>
<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
<tr>
<![endif]-->

<!--[if mso]>
<td valign="top" width="1000" style="width:1000px;">
<![endif]-->
        <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
            <tbody><tr>

                <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                  <h1 class="email-title">${title}</h1>
                  <br />
                  ${body}
                </td>
            </tr>
        </tbody></table>
<!--[if mso]>
</td>
<![endif]-->

<!--[if mso]>
</tr>
</table>
<![endif]-->
    </td>
</tr>
</tbody>
</table>
<table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width:100%; padding:18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width: 100%;border-top: 1px solid #DDDDDD;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table>
</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <!-- // END BODY -->
                        </td>
                    </tr>
                    <tr>
                        <td align="center" valign="top" style="padding-bottom:40px;">
                            <!-- BEGIN FOOTER // -->
                            <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templateFooter">
                                <tr>
                                    <td align="center" valign="top">
                                        <table border="0" cellpadding="0" cellspacing="0" width="1000" class="templateContainer">
                                            <tr>
                                                <td valign="top" class="footerContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
<tbody class="mcnDividerBlockOuter">
<tr>
    <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 9px 18px;">
        <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;">
            <tbody><tr>
                <td>
                    <span></span>
                </td>
            </tr>
        </tbody></table>
<!--
        <td class="mcnDividerBlockInner" style="padding: 18px;">
        <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
-->
    </td>
</tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
<tbody class="mcnTextBlockOuter">
<tr>
    <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
        <!--[if mso]>
<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
<tr>
<![endif]-->

<!--[if mso]>
<td valign="top" width="1000" style="width:1000px;">
<![endif]-->
        <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
            <tbody><tr>

                <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">

                    
<br>

                </td>
            </tr>
        </tbody></table>
<!--[if mso]>
</td>
<![endif]-->

<!--[if mso]>
</tr>
</table>
<![endif]-->
    </td>
</tr>
</tbody>
</table></td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                            <!-- // END FOOTER -->
                        </td>
                    </tr>
                </table>
                <!-- // END TEMPLATE -->
            </td>
        </tr>
    </table>
</center>
    </body>
</html>`;



//////////////////
// WEBPACK FOOTER
// ./src/shared/po-email-template.ts
// module id = 3101
// module chunks = 0